module.exports = __webpack_public_path__ + "static/shotlists_shots@3x-5291eb5d7ab1072641d7acd46b7ca0aa.png";